import { ServiceType as ServiceTypeSlug } from '@rover/constants/src/translations/service.constants';

import { SelectOption } from './SelectOption';

export type ServiceType = {
  accusativeObject: string;
  accusativeObjectSingular: string;
  action: string | null;
  alternativeRateUnit: string;
  alternativeRateUnitPlural: string;
  alternativeRateUnitTranslated: string;
  availabilityIsPerDog: boolean;
  browsable: boolean;
  description: string;
  displayName: string;
  endDateSelectorDescription: string;
  endTimeSelectorDescription: string;
  isDaytimeTraveling: boolean;
  ratePerPriceUnitLabel: string;
  icon: string;
  isEndDateExclusive: boolean;
  location: string;
  name: string;
  numUnitsPerDayLabel: string | null;
  showNewLabel: boolean;
  slug: string;
  startDateSelectorDescription: string;
  startTimeSelectorDescription: string;
  suggestedPetType: string;
  supportsDayOfWeekSearch: boolean;
  supportsNonContiguousDates: boolean;
  supportsNumUnitsPerDay: boolean;
  supportsRecurringBilling: boolean;
  supportsRepeatBookings: boolean;
  supportsServiceDeliveryVerification: boolean;
  supportsStartEndDate: boolean;
  usesFlexibleTimeRanges: boolean;
  visitDescription: string;
};

export { ServiceTypeSlug };

export type ServiceTypeOption = SelectOption<ServiceTypeSlug>;

export const ServiceTypeDefaults: ServiceType = {
  accusativeObject: '',
  accusativeObjectSingular: '',
  action: '',
  alternativeRateUnit: '',
  alternativeRateUnitPlural: '',
  alternativeRateUnitTranslated: '',
  availabilityIsPerDog: false,
  browsable: false,
  description: '',
  displayName: '',
  endDateSelectorDescription: '',
  endTimeSelectorDescription: '',
  icon: '',
  isEndDateExclusive: false,
  location: '',
  name: '',
  numUnitsPerDayLabel: '',
  showNewLabel: false,
  slug: '',
  startDateSelectorDescription: '',
  startTimeSelectorDescription: '',
  suggestedPetType: 'any',
  supportsDayOfWeekSearch: false,
  supportsNonContiguousDates: false,
  supportsNumUnitsPerDay: false,
  supportsRecurringBilling: false,
  supportsRepeatBookings: false,
  supportsServiceDeliveryVerification: false,
  supportsStartEndDate: false,
  usesFlexibleTimeRanges: false,
  visitDescription: '',
  isDaytimeTraveling: false,
  ratePerPriceUnitLabel: '1',
};
